import { cardTitle } from '../../assets/jss/wisene-material-dashboard-pro-react-types';
import { connect } from 'react-redux';
import { setRainstormMode } from '../../stores/actions/dashboardActions';
import Button from '../../../components/CustomButtons/ButtonTS';
import Card from '../../../components/Card/CardTS';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';
import CardIcon from '../../../components/Card/CardIcon.js';
import dashboardStyle from '../../assets/jss/views/dashboardStyleTS';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Loading from '../../components/Loading/Loading';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import React from 'react';
import styles from '../../assets/jss/views/dashboardStyle';
import {useState, useEffect} from 'react';

const style = {
	cardTitle,
	cardCategory: styles.cardCategory,
};
const rainstormIcon = <svg
width="50"
height="50"
viewBox="0 0 24 24"
fill="white"
>
<path d="M17.92 7.02C17.45 4.18 14.97 2 12 2 9.82 2 7.83 3.18 6.78 5.06 4.09 5.41 2 7.74 2 10.5 2 13.53 4.47 16 7.5 16h10c2.48 0 4.5-2.02 4.5-4.5 0-2.34-1.79-4.27-4.08-4.48M14.8 17l-2.9 3.32 2 1L11.55 24h2.65l2.9-3.32-2-1L17.45 17zm-6 0-2.9 3.32 2 1L5.55 24H8.2l2.9-3.32-2-1L11.45 17z"></path>
<path d="M0 0h24v24H0z" fill="none" />
</svg>;

const DEFAULT_DURATION_HOURS = 6;
const DURATION_HOURS_OPTIONS = Array.from({ length: 12 }, (_, i) => i + 1);

interface IRainstromModeCardProps {
	hideAlert: () => void;
    mobileView: boolean;
	systemID: number;
    rainstormModeEnd: string;
    rainstormModeNow: boolean;
    rainstormModeSettingSuccess: boolean;
    rainstormModeSettingFailed: boolean;
    w2ConfigurationUpdatedAt: string;
    setRainstormMode: (systemID: number, on: boolean, seconds: number, w2updatedAt: string) => void;
}

const RainstromModeCard  = (props: IRainstromModeCardProps) => {
    const {hideAlert, systemID, rainstormModeEnd,  rainstormModeNow, setRainstormMode, rainstormModeSettingSuccess,
           rainstormModeSettingFailed, w2ConfigurationUpdatedAt} = props;
    const [durationHours, setDurationHours] = useState(DEFAULT_DURATION_HOURS);
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        if (rainstormModeSettingSuccess || rainstormModeSettingFailed) {
            hideAlert();
        }
    }, [rainstormModeSettingSuccess, rainstormModeSettingFailed]);

    const onSubmitOn = () => {
        setSubmitted(true);
        setRainstormMode(systemID, true, durationHours * 3600, w2ConfigurationUpdatedAt);
    };

    const onSubmitOff = () => {
        setSubmitted(true);
        setRainstormMode(systemID, false, 0, w2ConfigurationUpdatedAt);
    };

    const durationSelect = (
        <TextField
            select
            id='rainstormModeDurationHours'
            label={rainstormModeNow ? 'New duration' : 'Duration'}
            value={durationHours}
            onChange={(e) => setDurationHours(Number(e.target.value))}
            style={{ minWidth: '160px' }}
            SelectProps={{ MenuProps: { style: { zIndex: 6000 } } }}
        >
            {DURATION_HOURS_OPTIONS.map((hours) => (
                <MenuItem key={hours} value={hours}>{hours} {hours === 1 ? 'hour' : 'hours'}</MenuItem>
            ))}
        </TextField>
    );

    const buttons = () => {
        if (submitted && !rainstormModeSettingSuccess && !rainstormModeSettingFailed) {
            return (
                <div style={{ width: '100%', marginTop: '25px', marginBottom: '10px', paddingLeft: '10px', paddingTop: '5px' }}>
                    <Loading transform={1} height={17} width={40} color='darkGray' />
                </div>);
        }
        if (rainstormModeNow) {
            return (
                <>
                    <Button color='info' onClick={onSubmitOn} className='downloadButton'>Update</Button>
                    <Button color='danger' onClick={onSubmitOff} className='downloadButton'>Turn off</Button>
                </>
            );
        }
        return <Button color='info' onClick={onSubmitOn} className='downloadButton'>Turn on</Button>;
    }

    return (
        <ErrorComponent Children message='Error'>
            <Card chart style={{ overflow: 'visible', marginTop: '10px', marginBottom: '0' }} className='node-edit-card'>
            <CardHeader color='info' icon>
                <CardIcon color='info'>
                   {rainstormIcon}
                </CardIcon>
                <h3 style={{ ...style.cardTitle, textAlign: 'left' }}>{"Rainstorm mode"}</h3>
            </CardHeader>
            <CardBody>
                <form>
                <GridContainer style={{ margin: '0 0 0 -15px' }}>
                    <GridItem xs={12} style={{ margin: '25px 0 0 0' }}>
                        {rainstormModeNow  ? <>
                            <p>Rainstorm mode active until:</p>
                            <p>{(new Date(rainstormModeEnd).toLocaleString('sv-SE').replace('T', ' '))}</p><br/>
                            </>
                            : <p>Rainstorm mode will be activated for the picked duration:</p>}
                    </GridItem>

                    <GridItem xs={12} style={{ margin: '10px 0 0 0' }}>
                        {durationSelect}
                    </GridItem>

                    <GridItem xs={12} style={{ margin: '25px 0 0 0', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        {buttons()}
                    </GridItem>
                </GridContainer>
                </form>
        </CardBody >
        </Card>
    </ErrorComponent>
    );
}



const mapStateToProps = (state) => {
    return {
        rainstormModeSettingSuccess: state.dashboard.rainstormModeSettingSuccess,
        rainstormModeSettingFailed: state.dashboard.rainstormModeSettingFailed,
        rainstormModeEnd: state.dashboard.system.rainstormModeEnd?.Time,
        rainstormModeNow: state.dashboard.system.rainstormModeNow,
        w2ConfigurationUpdatedAt: state.dashboard.system.w2ConfigurationUpdatedAt,
        moblieView: state.dashboard.mobileView
    }
}
const actions = { setRainstormMode };
export const ExportCardWithStyles = dashboardStyle(RainstromModeCard);
export default connect(mapStateToProps, actions)(ExportCardWithStyles);
